<template>
  <section class="speakers">
    <div class="speakers__content">
      <h1 class="speakers__title">
          Featured Speakers
      </h1>
      <div class="speakers__cards">
        <div class="speakers__cards--single">
          <button @click="pierce = true" class="speaker-btn">
            <img src="../assets/speakers/Pierce.jpg" alt="Brock Pierce">
            <h2>Brock Pierce</h2>
            <h4>Helios, CEO <br> Managing Partner, Mystic Ventures</h4>
          </button> 
          <transition name="fade" appear>
            <div class="modal-overlay" v-if="pierce" @click="pierce = false"></div>
          </transition>
          <transition name="pop" appear>
            <div class="modal" role="dialog" v-if="pierce">
              <div class="speaker-modal">
                <div class="speaker-thumbnail">
                  <img src="../assets/speakers/Pierce.jpg" alt="Brock Pierce">
                </div>
                <div class="speaker-info">
                  <h2>Brock Pierce</h2>
                  <h3>Helios, CEO || Managing Partner, Mystic Ventures</h3>
                  <p>Brock Pierce is a futurist, entrepreneur, philanthropist, and
                  impact investor with an extensive track record of founding,
                  advising and investing in disruptive businesses. He s
                  credited with pioneering the market for digital currency and
                  has raised more than $5B for companies he has founded,
                  opening opportunities for millions of people. Pierce is the
                  Chairman of the Bitcoin Foundation and co-founder of EOS
                  Alliance, Block.one, Blockchain Capital, Tether, and
                  Mastercoin (first ICO).</p>
                </div>
              </div>
              <button @click="pierce = false" class="close">⨉</button>
            </div>
          </transition>
        </div>

        <div class="speakers__cards--single">
          <button @click="sosnoff = true" class="speaker-btn">
            <img src="../assets/speakers/Sosnoff.png" alt="Tom Sosnoff">
            <h2>Tom Sosnoff</h2>
            <h4>tasty<i>live</i>, Founder & CEO</h4>
          </button>
          <transition name="fade" appear>
            <div class="modal-overlay" v-if="sosnoff" @click="sosnoff = false"></div>
          </transition>
          <transition name="pop" appear>
            <div class="modal" role="dialog" v-if="sosnoff">
              <div class="speaker-modal">
                <div class="speaker-thumbnail">
                  <img src="../assets/speakers/Sosnoff.png" alt="Tom Sosnoff">
                </div>
                <div class="speaker-info">
                  <h2>Tom Sosnoff</h2>
                  <h3>tasty<i>live</i>, Founder & CEO</h3>
                  <p>Tom Sosnoff is a trailblazer in the online brokerage industry, driving innovation and financial
                     education for investors of all levels. He offers up his expertise in the options markets as co-host
                     of <i>tastylive LIVE!</i>, airing daily on the <i>tastylive</i> network.
                     <br><br>
                    A former floor trader, Tom became one of Chicago's most well-known serial entrepreneurs in fintech
                    when he built a breakthrough options-trading platform, thinkorswim, later sold to TD-Ameritrade
                    for $750 million.
                    <br><br>
                    Leveraging over 20 years of experience as a Market Maker for the Chicago Board Options Exchange
                    (CBOE) and one of the original OEX traders in the S&P 100 Index pit, Tom pursued his vision
                    to educate retail investors in options trading and build a superior trading platform and a brokerage
                    firm that specialized in options. With that vision in mind, <i>tastylive</i> was founded in 2011.
                    Six years later, tastytrade launched with Scott Sheridan at the helm as CEO.
                  </p>
                </div>
              </div>
              <button @click="sosnoff = false" class="close">⨉</button>
            </div>
          </transition>
        </div>

        <div class="speakers__cards--single">
          <button @click="elder = true" class="speaker-btn">
            <img src="../assets/speakers/Elder.png" alt="Dr. Alexander Elder">
            <h2>Dr. Alexander Elder</h2>
            <h4>Trader and Author of Best Selling Trading Books</h4>
          </button>
          <transition name="fade" appear>
            <div class="modal-overlay" v-if="elder" @click="elder = false"></div>
          </transition>
          <transition name="pop" appear>
            <div class="modal" role="dialog" v-if="elder">
              <div class="speaker-modal">
                <div class="speaker-thumbnail">
                  <img src="../assets/speakers/Elder.png" alt="Dr. Alexander Elder">
                </div>
                <div class="speaker-info">
                  <h2>Dr. Alexander Elder</h2>
                  <h3>Trader and Author of Best Selling Trading Books</h3>
                  <p>Alexander Elder, M.D., is a professional trader and a teacher
                  of traders. His books, including The New Trading for a Living
                  are international bestsellers among private and
                  institutional traders, translated into 17 languages. Dr Elder
                  was trained as a psychiatrist and served on the faculty of
                  Columbia University. Now he is a full-time trader who
                  shares his hard-earned lessons with his students.</p>
                </div>
              </div>
              <button @click="elder = false" class="close">⨉</button>
            </div>
          </transition>
        </div>

        <div class="speakers__cards--single">
          <button @click="jon = true" class="speaker-btn">
            <img src="../assets/speakers/Najarian.jpg" alt="Jon “DRJ” Najarian">
            <h2>Jon “DRJ” Najarian</h2>
            <h4>Market Rebellion, Co-Founder</h4>
          </button>
          <transition name="fade" appear>
            <div class="modal-overlay" v-if="jon" @click="jon = false"></div>
          </transition>
          <transition name="pop" appear>
            <div class="modal" role="dialog" v-if="jon">
              <div class="speaker-modal">
                <div class="speaker-thumbnail">
                  <img src="../assets/speakers/Najarian.jpg" alt="Jon “DRJ” Najarian">
                </div>
                <div class="speaker-info">
                  <h2>Jon “DRJ” Najarian</h2>
                  <h3>Market Rebellion, Co-Founder</h3>
                  <p>Jon 'DRJ' Najarian was linebacker for the Chicago Bears before he turned to another
                    kind of a contact sport - trading on the Chicago Board Options Exchange. He became
                    a member of the CBOE, NYSE, CME and CBOT and worked as a floor trader for some
                    25 years. In 1990 he founded Mercury Trading, a market-making firm at the Chicago
                    Board Options Exchange (CBOE), which he sold in 2004 to Citadel, one of the world's
                    largest hedge funds. In 2005 Jon co-founded optionMONSTER and tradeMONSTER,
                    sold a majority stake to private equity firm General Atlantic Partners in 2014 & two years
                    later sold the firm to E*Trade for $750M. Today, he is a host on a variety of mainstream
                    financial news netwoks, a professional investor, money manager, market strategist and
                    venture evangelist. Jon is also a co-host and co-founder of proprietary programming
                    including the popular “Rebels' Edge” streaming show and the “Bulls, Bears &
                    Blockchain” radio show.
                    <br><br>
                    Jon is also chairman of a technology SPAC, an investor and senior advisor to IDI
                    Group, LLC (a multi-family office) and co-founder of Moneta Advisory Partners, LLC, a
                    “venture evangelism” platform that raises awareness of a portfolio of growing public
                    companies.
                  </p>
                </div>
              </div>
              <button @click="jon = false" class="close">⨉</button>
            </div>
          </transition>
        </div>

        <div class="speakers__cards--single">
          <button @click="medha = true" class="speaker-btn">
            <img src="../assets/speakers/Medha.jpg" alt="Medha Parlikar">
            <h2>Medha Parlikar</h2>
            <h4>Casper Labs, CTO</h4>
          </button>
          <transition name="fade" appear>
            <div class="modal-overlay" v-if="medha" @click="medha = false"></div>
          </transition>
          <transition name="pop" appear>
            <div class="modal" role="dialog" v-if="medha">
              <div class="speaker-modal">
                <div class="speaker-thumbnail">
                  <img src="../assets/speakers/Medha.jpg" alt="Medha Parlikar">
                </div>
                <div class="speaker-info">
                  <h2>Medha Parlikar</h2>
                  <h3>Casper Labs, Co-Founder & Chief Technology Officer</h3>
                  <p>Medha Parlikar is co-founder and CTO of CasperLabs. Medha has more
                    than 30 years of tech experience and is considered one of the top women
                    in blockchain. She started working with technology in the early 1980's,
                    building computers in the basement. For the past two decades, she has been
                    delivering production SaaS software for large companies including Adobe,
                    Omniture and Avalara. Medha excels in building high-functioning technical teams,
                    and inspiring them to deliver solutions that solve customer problems. Medha holds a
                    Bachelor's Degree in Computer Information Systems and Programming from Coleman
                    College.</p>
                </div>
              </div>
              <button @click="medha = false" class="close">⨉</button>
            </div>
          </transition>
        </div>

        <div class="speakers__cards--single">
          <button @click="marc = true" class="speaker-btn">
            <img src="../assets/speakers/LoPresti.png" alt="Marc X. LoPresti">
            <h2>Marc X. LoPresti</h2>
            <h4>IDI Group, Founder & Managing Director</h4>
          </button>
          <transition name="fade" appear>
            <div class="modal-overlay" v-if="marc" @click="marc = false"></div>
          </transition>
          <transition name="pop" appear>
            <div class="modal" role="dialog" v-if="marc">
              <div class="speaker-modal">
                <div class="speaker-thumbnail">
                  <img src="../assets/speakers/LoPresti.png" alt="Marc X. LoPresti">
                </div>
                <div class="speaker-info">
                  <h2>Marc X. LoPresti</h2>
                  <h3>IDI Group, Founder & Managing Director</h3>
                  <p>
                    Marc is a Wall Street veteran with over 25+ years' experience in alternative
                    investments, having started his career on the floor of the NYSE working for Lehman
                    Brothers.  Marc is currently: Co-Founder & Managing Director, IDI Group (a global multi-
                    family office focused on early-stage venture investments), Co-Founder & Managing
                    Director, Moneta Advisory Partners (a “Venture Evangelism” platform), Co-Founder &
                    Board Member, BattleFin Group (a leading alternative data company), and Co-Founder,
                    Revolution Media Group (producer of the popular “Bulls, Bears & Blockchain” podcast).
                    Marc was also the founder of LoPresti Law Group, LLC, a leading securities law firm in
                    New York focused on alternative investments.
                    <br><br>
                    Marc appears regularly on CNBC, CoindeskTV, TD Ameritrade Network, Sirius XM
                    Radio, Bloomberg, and Fox.  He has been quoted in numerous publications including
                    Forbes, Reuters, the Wall Street Journal, Investor's Business Daily, and Barron's.
                    <br>
                  </p>
                </div>
              </div>
              <button @click="marc = false" class="close">⨉</button>
            </div>
          </transition>
        </div>

        <div class="speakers__cards--single">
          <button @click="ella = true" class="speaker-btn">
            <img src="../assets/speakers/Ella.jpg" alt="Ella Woger Nieves">
            <h2>Ella Woger Nieves</h2>
            <h4>Invest Puerto Rico, Chief Executive Officer</h4>
          </button>
          <transition name="fade" appear>
            <div class="modal-overlay" v-if="ella" @click="ella = false"></div>
          </transition>
          <transition name="pop" appear>
            <div class="modal" role="dialog" v-if="ella">
              <div class="speaker-modal">
                <div class="speaker-thumbnail">
                  <img src="../assets/speakers/Ella.jpg" alt="Ella Woger Nieves">
                </div>
                <div class="speaker-info">
                  <h2>Ella Woger Nieves</h2>
                  <h3>Invest Puerto Rico, Chief Executive Officer</h3>
                  <p>
                    A Puerto Rico native, Ella brings 20 years of experience in strategic marketing and
                    management consulting to strengthen Invest Puerto Rico's endeavors. She played an
                    instrumental role in the organization's creation, helping establish InvestPR's mission,
                    objectives, and roadmap to accomplishing them. A true believer in the island's potential as a
                    world-class investment destination, Ella ensures that all stakeholders - internal and external
                    - are aligned to InvestPR's vision of being a transformational and results-oriented accelerator
                    of economic development in Puerto Rico.
                  </p>
                </div>
              </div>
              <button @click="ella = false" class="close">⨉</button>
            </div>
          </transition>
        </div>

      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/speakers.scss';
</style>

<script>

export default {
  name: 'Speakers',

  data() {
    return {
      pierce: false,
      elder: false,
      medha: false,
      sosnoff: false,
      jon: false,
      marc: false,
      ella: false
    };
  },
};
</script>